"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var castDateToISO_1 = __importDefault(require("./castDateToISO"));
var isMaxMonth = function (date, maxDate) {
    if (!maxDate)
        return false;
    var lastDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    var isoLast = (0, castDateToISO_1.default)(lastDate);
    var isoMax = (0, castDateToISO_1.default)(maxDate);
    return isoLast >= isoMax;
};
exports.default = isMaxMonth;
